import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import classes from "./CreateGroup.module.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../../components/Common/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import {
  checkUniqueUserGroupNameActionHandler,
  postUserGroupActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { FormattedMessage } from "react-intl";

const nameSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
});

const CreateGroup = ({
  handleSearchQuery,
  setCreateGroupModal,
  setAddUserModal,
}) => {
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: { role: "" },
    resolver: yupResolver(nameSchema),
  });
  const { handleSubmit, watch } = methods;

  const [nameErrorMsg, setNameErrorMsg] = useState("");
  const [isNameExistLoader, setIsNameExistLoader] = useState(false);
  const [createNameLoading, setcreateNameLoading] = useState(false);
  const [alphanumericCheckErrorMsg, setAlphanumericCheckErrorMsg] =
    useState("");
  const nameVal = watch("name");

  const onSubmit = (data) => {
    setcreateNameLoading(true);
    const payload = {
      ID: "",
      Name: nameVal,
      UserList: "",
      UserSubGroups: "",
    };
    dispatch(postUserGroupActionHandler(payload)).then((response) => {
      if (response.data) {
        setcreateNameLoading(false);
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `${payload.Name} user group has been saved succesfully.`
          )
        );
        handleSearchQuery();
        setCreateGroupModal(false);
        setAddUserModal(true);
      } else
        dispatch(setErrorHandler(errorTypes.FAIL, "Group Creation Failed"));
    });
  };

  const handleName = (e) => {
    const val = e.target.value.trim() !== "" && e.target.value;
    if (val) {
      const regex = new RegExp(/^[a-zA-Z0-9:_@#?|'`\][ ]*$/);
      if (!regex.test(val))
        setAlphanumericCheckErrorMsg(
          "Only alphanumeric and special characters like ':#@?[]_`| are allowed"
        );
      else {
        setAlphanumericCheckErrorMsg("");
        setIsNameExistLoader(true);
        dispatch(checkUniqueUserGroupNameActionHandler(val)).then(
          (response) => {
            if (response && response?.status === 200) {
              const isGroupNamePresent = response?.data?.UserGroups?.some(
                (e) => e?.Name?.toLowerCase() === val?.toLowerCase()
              );
              if (isGroupNamePresent) {
                setIsNameExistLoader(false);
                setNameErrorMsg("Name is already exists");
              } else {
                setIsNameExistLoader(false);
                setNameErrorMsg("");
              }
            }
          }
        );
      }
    } else {
      setNameErrorMsg("");
      setIsNameExistLoader(false);
    }
  };

  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.createNewGroup}
        >
          <div className={classes.textField}>
            <Input
              label={<FormattedMessage id="USERMANAGE_SEARCHNAME" />}
              name="name"
              fieldName="name"
              placeholder="Enter Name"
              labelColor="light"
              required
              maxLength="100"
              onChange={(e) => handleName(e)}
              loading={isNameExistLoader}
              labelMsg="(Max: 100 Characters)"
            />
          </div>
          {nameErrorMsg &&
            !isNameExistLoader &&
            !alphanumericCheckErrorMsg &&
            nameVal && (
              <div className={classes.errorMessage}>{nameErrorMsg}</div>
            )}
          {alphanumericCheckErrorMsg && !isNameExistLoader && nameVal && (
            <div className={classes.errorMessage}>
              {alphanumericCheckErrorMsg}
            </div>
          )}

          <div className={classes.btn}>
            <Button
              type="submit"
              label={<FormattedMessage id="SAVE_TXT" />}
              small
              dark
              backgroundColor={createNameLoading ? undefined : "#D31B61"}
              loading={createNameLoading}
              disabled={
                !nameVal ||
                nameErrorMsg ||
                isNameExistLoader ||
                alphanumericCheckErrorMsg ||
                !nameVal?.trim()
              }
            />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default React.memo(CreateGroup);
